/**
 * The currently selected slide inside the slides has changed
 */
export class CarouselSliderSlideChangeEvent extends Event {
  public static readonly KEY = "CarouselSliderSlideChangeEvent";

  constructor(public readonly index: number, public scrollOffset: number) {
    super(CarouselSliderSlideChangeEvent.KEY);
  }
}
